var map = {
	"./": 5470,
	"./development": 4128,
	"./development.ts": 4128,
	"./index": 5470,
	"./index.ts": 5470,
	"./localhost": 9237,
	"./localhost.ts": 9237,
	"./namespace": 9924,
	"./namespace.ts": 9924,
	"./production": 9813,
	"./production.ts": 9813
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8391;